<script>
import { Line } from 'vue-chartjs';
import { toCurrency, commaSeparated } from '@/utils/etc.js';
import { apiGetTotalGrossProfit } from '@/api/statistics/statistics.js';

export default {
	extends: Line,
	props: {
		unit: String,
		year: Number,
		month: Number,
		sales_group_code: String,
	},
	computed: {
		from_date: {
			get: function() {
				if (this.unit.toUpperCase() === 'DAY') return this.year + '-' + this.month + '-' + '01';
				else if (this.unit.toUpperCase() === 'MONTH') return this.year + '-01-01';
				else return null;
			},
		},
		to_date: {
			get: function() {
				let date = null;
				if (this.unit.toUpperCase() === 'DAY') date = new Date(this.year, this.month, 0);
				else if (this.unit.toUpperCase() === 'MONTH') date = new Date(this.year, 11, 31);
				else return null;

				return date.getFullYear() + '-' + (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1) + '-' + date.getDate();
			},
		},
	},
	async mounted() {
		let { data } = await apiGetTotalGrossProfit(this.unit, this.from_date, this.to_date, this.sales_group_code);

		let total_sale_data = data.map(el => el.total_sale);
		let cost_data = data.map(el => el.cost);
		let gross_profit_data = data.map(el => el.gross_profit);
		let labels = data.map(el => {
			if (this.unit === 'DAY') return el.date.substr(3, 2);
			else if (this.unit === 'MONTH') return el.date.substr(0, 2);
		});

		let sum_sale = 0;
		let sum_cost = 0;
		let sum_gross_profit = 0;
		total_sale_data.forEach(el => {
			if (el) sum_sale += el;
		});
		cost_data.forEach(el => {
			if (el) sum_cost += el;
		});
		sum_gross_profit = sum_sale - sum_cost;

		this.renderChart(
			{
				labels,
				datasets: [
					{
						label: 'SALES',
						borderColor: this.$colorsForLineChart[0],
						pointBackgroundColor: this.$colorsForLineChart[0],
						fill: false,
						data: total_sale_data,
					},
					{
						label: 'GROSS PROFIT',
						borderColor: this.$colorsForLineChart[1],
						pointBackgroundColor: this.$colorsForLineChart[1],
						fill: false,
						data: gross_profit_data,
					},
					{
						label: 'COST',
						borderColor: this.$colorsForLineChart[2],
						pointBackgroundColor: this.$colorsForLineChart[2],
						fill: false,
						data: cost_data,
					},
				],
			},

			{
				animation: {
					duration: 1,
				},
				hover: {
					mode: 'index',
					intersect: false,
					// onHover: function(e) {
					// 	// tooltip 출현 위치 오류
					// 	console.log(this.chart.tooltip);
					// 	let rect = e.target.getBoundingClientRect();

					// 	if (e.clientY < rect.bottom - rect.height / 5) {
					// 		// this.chart.tooltip._options.enabled = false;
					// 		this.chart.tooltip._options.custom = function(tooltipModel) {
					// 			tooltipModel.opacity = 0;
					// 		};
					// 	} else {
					// 		// this.chart.tooltip._options.enabled = true;
					// 		this.chart.tooltip._options.custom = function(tooltipModel) {
					// 			tooltipModel.opacity = 1;
					// 		};
					// 	}
					// },
				},
				tooltips: {
					mode: 'index',
					intersect: false,
					position: 'bottom',
					xAlign: 'center',
					yAlign: 'bottom',
					callbacks: {
						title: function() {
							// return data['labels'][tooltipItemList[0]['index']];
							return null;
						},
						label: function(tooltipItem) {
							let label = tooltipItem.yLabel;
							return toCurrency(label);
						},
					},
					backgroundColor: '#C4D5FF',
					titleFontSize: 12,
					titleFontColor: '#0066ff',
					bodyFontColor: '#000',
					bodyFontSize: 12,
					displayColors: true,
				},
				responsive: true,
				maintainAspectRatio: false,
				elements: {
					line: {
						fill: false,
						tension: 0,
						borderWidth: 2,
					},
				},
				scales: {
					/* xAxes: [
						{
							ticks: {
								maxRotation: 90,
								// minRotation: 90,
								minRotation: 0,
							},
						},
					],*/
					yAxes: [
						{
							ticks: {
								// min: 0,
								// max: 100,
								// stepSize: 10,
								minRotation: 45,
								callback: value => commaSeparated(value),
							},
						},
					],
				},
				plugins: {
					datalabels: {
						display: false,
					},
				},
			},
		);

		this.$emit('emitSumData', { SALE: sum_sale, COST: sum_cost, 'GROSS PROFIT': sum_gross_profit });

		this.$nextTick(() => {
			this.$refs.canvas.style.height = '300px';
		});
	},
};
</script>
